import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import GoodsList from './GoodsList';
import GoodsDetail from './GoodsDetail';

@inject(({ commonStore, goodsInfoStore }) => ({
  commonStore: commonStore,

  setCommonStoreInfo: goodsInfoStore.setCommonStoreInfo,
  onClear: goodsInfoStore.onClear,
  viewMode: goodsInfoStore.viewMode,
  onViewMode: goodsInfoStore.onViewMode,
  disGoodsList: goodsInfoStore.disGoodsList,
}))
@observer
class GoodsContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disGoodsList(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/goodsManage');
      } else {
        this.props.history.push('/goodsManage/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    const { viewMode } = this.props;
    return (
      viewMode === 'list'
      ? <GoodsList 
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
        /> 
      : <GoodsDetail 
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
        />
    );
  }

}

export default withRouter(GoodsContainer);
